import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import useApi from "../../Hooks/useApi";
import ErrorHandler from "../../Components/Shared/ErrorHandler.js";
import Password from "../../Components/UI/Inputs/Password.js";
import Button from "../../Components/UI/Buttons/Button";
import showToast from "../../Helpers/toast";
import NavigateButton from "../../Components/UI/Buttons/NavigateButton";

export default function ChangePassword() {
  const initialFormState = {
    current_password: "",
    new_password: "",
    confirm_password: "",
  };
  const { request, error } = useApi();
  const [showPassword, setShowPassword] = useState(false);
  const [formData, setFormData] = useState(initialFormState);
  const navigate = useNavigate();

  const { t } = useTranslation();

  const handleInputChange = (name, value) => {
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleNewPasswordSubmit = async () => {
    const { current_password, confirm_password, new_password } = formData;

    if (!new_password || confirm_password !== new_password) {
      showToast({ message: "Passwords do not match", type: "error" });
      return;
    }

    try {
      const response = await request("POST", "/v1/auth/change-password", {
        data: {
          password: new_password,
          retypePassword: confirm_password,
          oldPassword: current_password,
        },
      });

      showToast({ message: response.message });
      navigate("/modules");
    } catch (error) {}
  };

  if (error) {
    return <ErrorHandler errors={error} />;
  }

  return (
    <div className="px-2 w-full h-full py-20">
      <div className="py-2 float-center">
        <NavigateButton text="back" />
      </div>
      <div className="border-2 border-[#E0F5FD] rounded lg:w-[500px] shadow-md mx-auto p-5">
        <h2 className="text-2xl font-bold text-[#7DDBFF]">
          {t("Change Password")}
        </h2>

        <div className="flex flex-col !px-[8%] h-full mb-[8%]">
          <p className="text-[#6F6F6F] text-sm my-2">
            {t("Please enter current password.")}
          </p>
          <Password
            // label={"Current Password"}
            required
            placeholder={t("Current password")}
            name="current_password"
            showPassword={showPassword}
            onValueChange={handleInputChange}
            togglePassword={() => setShowPassword(!showPassword)}
            value={formData.current_password}
          />
          <hr />
          <p className="text-[#6F6F6F] text-sm my-2">
            {t("Please enter a new password.")}
          </p>

          <Password
            required
            placeholder={t("New password")}
            name="new_password"
            showPassword={showPassword}
            onValueChange={handleInputChange}
            togglePassword={() => setShowPassword(!showPassword)}
            value={formData.new_password}
          />
          <Password
            required
            placeholder={t("Re-type new password")}
            name="confirm_password"
            showPassword={showPassword}
            onValueChange={handleInputChange}
            togglePassword={() => setShowPassword(!showPassword)}
            value={formData.confirm_password}
          />
          {/* <ShowError error={error} /> */}
          <Button
            type="full"
            label={t("Submit")}
            textColor="white"
            backgroundColor="#7DDBFF"
            handler={handleNewPasswordSubmit}
          />
        </div>
      </div>
    </div>
  );
}
